var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightVariable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 60",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1 29.5h70v1H-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4 59.4l-.8-.8L68.3 30 39.6 1.4l.8-.8L69.7 30z"
  })));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgNzAgNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiPgoJPHBhdGggZD0iTS0xIDI5LjVoNzB2MUgtMXoiLz4KCTxwYXRoIGQ9Ik00MC40IDU5LjRsLS44LS44TDY4LjMgMzAgMzkuNiAxLjRsLjgtLjhMNjkuNyAzMHoiLz4KPC9zdmc+";
export { SvgArrowRightVariable as ReactComponent };